import React from 'react'
import './About.css'
import {ReactComponent as Circle1} from '../../assets/circle1.svg'
import {ReactComponent as Circle2} from '../../assets/circle2.svg'
import {ReactComponent as Circle3} from '../../assets/circle3.svg'
import {ReactComponent as Circle4} from '../../assets/circle4.svg'

function About(props) {
    return (
        <div className="aboutWrapper">
            <div className="aboutItems" >
                <div className="aboutItem" >
                    <div className="aboutCircle"><Circle1/></div>
                    <h4 style={{fontFamily:"PPPangramSansRounded-Medium", lineHeight:"24px"}} className="aboutItemTitle">{props.aboutTitle1}</h4>
                    <p style={{color:"rgba(0, 0, 12, 0.5)", fontSize:"14px", lineHeight:"20px"}}className="aboutItemContent">
                        {props.aboutContent1}
                    </p>    
                </div>
                <div className="aboutItem">
                    <div className="aboutCircle"><Circle2 style={{marginTop:"25px"}}/></div>
                    <h4 style={{fontFamily:"PPPangramSansRounded-Medium", lineHeight:"24px"}} className="aboutItemTitle">{props.aboutTitle2}</h4>
                    <p style={{color:"rgba(0, 0, 12, 0.5)", fontSize:"14px", lineHeight:"20px"}}className="aboutItemContent">{props.aboutContent2}</p>
                </div>
                <div className="aboutItem">
                    <div className="aboutCircle"><Circle3/></div>
                    <h4 style={{fontFamily:"PPPangramSansRounded-Medium", lineHeight:"24px"}} className="aboutItemTitle">{props.aboutTitle3}</h4>
                    <p style={{color:"rgba(0, 0, 12, 0.5)", fontSize:"14px", lineHeight:"20px"}}className="aboutItemContent">{props.aboutContent3}</p>
                </div>
                <div className="aboutItem">
                    <div className="aboutCircle"><Circle4 style={{marginLeft:"25px"}}/></div>
                    <h4 style={{fontFamily:"PPPangramSansRounded-Medium", lineHeight:"24px"}} className="aboutItemTitle">{props.aboutTitle4}</h4>
                    <p className="aboutItemContent" style={{color:"rgba(0, 0, 12, 0.5)", fontSize:"14px", lineHeight:"20px"}}>{props.aboutContent4}</p>
                </div>                
            </div>
        </div>
    )
}

export default About
